<p class="info-text small">
  {{ 'begin_review_msg_1' | translate }}
</p>
<p class="info-text small">
  {{ 'begin_review_msg_2' | translate }}
</p>
<p class="info-text small">
  {{ 'begin_review_msg_3' | translate }}
</p>
<p class="info-text small">
  {{ 'begin_review_msg_4' | translate }}
</p>

<form [formGroup]="formChecks">
  <div class="checkbox">
    <input type="checkbox" id="acepted-fipre" formControlName="fipre" />
    @if (!isdownloadByUrl) {
      <label class="small acepted-fipre" for="acepted-fipre"
        ><span [innerHTML]="'begin_review_acepted_fipre' | translate"></span>
        <a
          id="tooltip-fipre-diprec"
          class="icon-a"
          href="javascript:void(0)"
          tooltipEvent="focus"
          (click)="openToast('tooltip-fipre-diprec')"
          [pTooltip]="'begin_review_acepted_fipre_info' | translate"
        >
          <img class="ico-info" src="assets/img/info.svg"
        /></a>
        @if (!downloading) {
          <a class="btn btn-03 btn-fipre" (click)="downloadFIPRE()" href="javascript:void(0)">{{
            'begin_review_download' | translate
          }}</a>
        } @else {
          <a class="btn btn-03 btn-fipre disabled" href="javascript:void(0)">{{
            'begin_review_downloading' | translate
          }}</a>
        }
      </label>
    } @else {
      <label class="small" for="acepted-fipre"
        ><span [innerHTML]="'begin_review_acepted_fipre' | translate"></span>
        <a
          id="tooltip-fipre-diprec"
          class="icon-a"
          href="javascript:void(0)"
          tooltipEvent="focus"
          (click)="openToast('tooltip-fipre-diprec')"
          [pTooltip]="'begin_review_acepted_fipre_info' | translate"
        >
          <img class="ico-info" src="assets/img/info.svg"
        /></a>
        @if (urlFipre) {
          <a class="btn btn-03 btn-fipre" #donwload (click)="setDownloaded(donwload)" target="_blank">{{
            'begin_review_download' | translate
          }}</a>
        } @else {
          <a class="btn btn-03 btn-fipre disabled" href="javascript:void(0)">{{
            'begin_review_generate_pdf' | translate
          }}</a>
        }
      </label>
    }
  </div>

  @if (formChecks.controls['fipre'].touched && formChecks.controls['fipre'].invalid) {
    <p class="has-error">
      {{ 'begin_review_must_acepted_document' | translate }}
    </p>
  }

  @if (msgPDFDownloaded) {
    <p class="has-error">
      {{ msgPDFDownloaded | translate }}
    </p>
  }

  <div class="checkbox">
    <input type="checkbox" id="acepted-cirbe" formControlName="cirbe" />
    <label class="small" for="acepted-cirbe">
      {{ 'begin_review_acepted_check_cirbe' | translate }}
      <a
        id="tooltip-cirbe"
        class="icon-a"
        href="javascript:void(0)"
        tooltipEvent="focus"
        (click)="openToast('tooltip-cirbe')"
        [pTooltip]="'begin_review_acepted_check_cirbe_info' | translate"
      >
        <img class="ico-info" src="assets/img/info.svg" /></a
    ></label>
  </div>
  @if (formChecks.controls['cirbe'].touched && formChecks.controls['cirbe'].invalid) {
    <p class="has-error">
      {{ 'begin_review_must_acepted_cirbe' | translate }}
    </p>
  }
</form>

<div class="form-btn-group col-12 no-pd d-flex justify-content-end">
  <a class="btn btn-01" routerLink="estudio-economico" (click)="cancel()">{{
    'begin_review_btn_modify' | translate
  }}</a>
  <a class="btn btn-02" href="javascript:void(0)" (click)="accept()">{{ 'begin_review_btn_continue' | translate }}</a>
</div>
